// Remix Icon (design system §6.3: open-source SVG icons). Inlined as SVG so they take the text
// colour (Magenta Bloom or Prussian Blue on light backgrounds) and need no icon font.
import arrowLeft from 'remixicon/icons/Arrows/arrow-left-line.svg?raw';
import building from 'remixicon/icons/Buildings/building-line.svg?raw';
import check from 'remixicon/icons/System/check-line.svg?raw';
import close from 'remixicon/icons/System/close-line.svg?raw';
import database from 'remixicon/icons/Device/database-2-line.svg?raw';
import download from 'remixicon/icons/System/download-2-line.svg?raw';
import errorWarning from 'remixicon/icons/System/error-warning-line.svg?raw';
import eye from 'remixicon/icons/System/eye-line.svg?raw';
import fileText from 'remixicon/icons/Document/file-text-line.svg?raw';
import folder from 'remixicon/icons/Document/folder-3-line.svg?raw';
import information from 'remixicon/icons/System/information-line.svg?raw';
import lock from 'remixicon/icons/System/lock-line.svg?raw';
import logout from 'remixicon/icons/System/logout-box-r-line.svg?raw';
import search from 'remixicon/icons/System/search-line.svg?raw';

const icons = {
  arrowLeft,
  building,
  check,
  close,
  database,
  download,
  errorWarning,
  eye,
  fileText,
  folder,
  information,
  lock,
  logout,
  search,
};

export type IconName = keyof typeof icons;

// Remix SVGs ship with fixed width/height; strip them so CSS sizes the icon.
const sized = Object.fromEntries(
  Object.entries(icons).map(([name, svg]) => [
    name,
    svg.replace(/\s(width|height)="[^"]*"/g, '').replace('<svg', '<svg fill="currentColor" width="100%" height="100%"'),
  ]),
) as Record<IconName, string>;

export function Icon({ name, className = 'h-5 w-5', label }: { name: IconName; className?: string; label?: string }) {
  return (
    <span
      className={`inline-block shrink-0 ${className}`}
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      dangerouslySetInnerHTML={{ __html: sized[name] }}
    />
  );
}
